import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class DocumentAdministrationLetterMeta extends BaseEntityModel {
  /**
   * @var {number}
   */
  parentId;

  /**
   * @var {string}
   */
  issuedOn;

  /**
   * @var {string}
   */
  expiresOn;

  constructor(model = {}) {
    super(model);

    this.parentId = model.parentId;
    this.issuedOn = model.issuedOn;
    this.expiresOn = model.expiresOn;
  }
}
